import React, { Component } from 'react';
import { connect } from 'react-redux';
import { replace } from 'redux-router';
import { routerHistoryBackAction, navigationShow } from 'actions';

import Icon from 'components/common/Icon';

class Header extends Component {
  state = {
    leftButtonWidth: 32,
    rightButtonWidth: 32,
    titleWidth: 250,
    headerWidth: 320,
  }

  /* eslint react/no-did-mount-set-state: 0 */
  // This setState should be ok since we make sure it's not the current state value
  // to reduce the chance of thrashing

  componentDidMount() {
    if (this.props.headerContent !== false) {
      if (this.refLeftButton) {
        const leftButtonWidth = this.refLeftButton.getBoundingClientRect().width;
        if (leftButtonWidth !== this.state.leftButtonWidth) {
          this.setState({ leftButtonWidth });
        }
      }

      if (this.refRightButton) {
        const rightButtonWidth = this.refRightButton.getBoundingClientRect().width;
        if (rightButtonWidth !== this.state.rightButtonWidth) {
          this.setState({ rightButtonWidth });
        }
      }

      if (this.refTitle) {
        const titleWidth = this.refTitle.getBoundingClientRect().width;
        if (titleWidth !== this.state.titleWidth) {
          this.setState({ titleWidth });
        }
      }

      if (this.refHeader) {
        const headerWidth = this.refHeader.getBoundingClientRect().width;
        if (headerWidth !== this.state.headerWidth) {
          this.setState({ headerWidth });
        }
      }
    }
  }

  /* eslint react/no-did-update-set-state: 0 */
  // This setState should be ok since we make sure it's not the current state value
  // to reduce the chance of thrashing

  componentDidUpdate() {
    if (this.props.headerContent !== false) {
      if (this.refLeftButton) {
        const leftButtonWidth = this.refLeftButton.getBoundingClientRect().width;
        if (leftButtonWidth !== this.state.leftButtonWidth) {
          this.setState({ leftButtonWidth });
        }
      }

      if (this.refRightButton) {
        const rightButtonWidth = this.refRightButton.getBoundingClientRect().width;
        if (rightButtonWidth !== this.state.rightButtonWidth) {
          this.setState({ rightButtonWidth });
        }
      }

      if (this.refTitle) {
        const titleWidth = this.refTitle.getBoundingClientRect().width;
        if (titleWidth !== this.state.titleWidth) {
          this.setState({ titleWidth });
        }
      }

      if (this.refHeader) {
        const headerWidth = this.refHeader.getBoundingClientRect().width;
        if (headerWidth !== this.state.headerWidth) {
          this.setState({ headerWidth });
        }
      }
    }
  }

  render() {
    const { headerContent, showBack, rightAction, routerHistory } = this.props;
    let { backTitle } = this.props;
    const style = { visibility: 'visible' };
    let leftAction;

    if (headerContent === false) {
      style.visibility = 'hidden';
    }

    if (typeof showBack === 'string' || typeof showBack === 'function' || (showBack && routerHistory.length > 1)) {
      let onClick = () => {};

      if (typeof showBack === 'string') {
        onClick = () => {
          this.props.replace(showBack);
        };
      } else if (typeof showBack === 'function') {
        onClick = () => {
          const backAction = showBack(routerHistory[1] || {});
          if (backAction === true) {
            const go = routerHistory[1];
            this.props.replace({ state: go.state, pathname: go.pathname, query: go.query });
            this.props.routerHistoryBackAction();
          } else {
            this.props.replace(backAction);
          }
        };
      } else {
        onClick = () => {
          const go = routerHistory[1];
          this.props.replace({ state: go.state, pathname: go.pathname, query: go.query });
          this.props.routerHistoryBackAction();
        };
      }

      if (typeof backTitle === 'function') {
        backTitle = backTitle(routerHistory[1] || {});
      }

      leftAction = (
        <a
          className="clickable"
          style={{ marginLeft: -6 }}
          onClick={onClick}
        >
          <Icon icon="arrow" className="rotate-180" size="large" />
          <span className="label" style={{ marginLeft: -2 }}>{backTitle}</span>
        </a>
      );
    } else {
      leftAction = (
        <Icon
          icon="hamburger"
          size="large"
          clickable
          onClick={() => this.props.navigationShow()}
          className="hamburger"
        />
      );
    }

    if (this.props.leftAction) {
      leftAction = this.props.leftAction;
    }

    /* Dynamic layout for header width based on content already
       An in-depth discussion: http://cheeaun.com/blog/2012/03/how-i-built-hacker-news-mobile-web-app_26/ */
    const { leftButtonWidth, rightButtonWidth, titleWidth, headerWidth } = this.state;
    const maxButton = Math.max(leftButtonWidth, rightButtonWidth);
    let marginLeft = maxButton;
    let marginRight = maxButton;
    if (((maxButton * 2) + titleWidth) > headerWidth) {
      marginLeft = leftButtonWidth;
      marginRight = rightButtonWidth;

      if ((leftButtonWidth + rightButtonWidth + titleWidth) < headerWidth) {
        if (marginLeft > marginRight) {
          marginRight = headerWidth - titleWidth - leftButtonWidth;
        } else {
          marginLeft = headerWidth - titleWidth - rightButtonWidth;
        }
      }
    }

    return (
      <header ref={(ref) => { this.refHeader = ref; }} style={style}>
        <span className="leftButton" ref={(ref) => { this.refLeftButton = ref; }}>
          {leftAction}
        </span>
        <div
          className="headerTitle"
          style={{ marginLeft, marginRight }}
        >
          <span ref={(ref) => { this.refTitle = ref; }}>{headerContent}</span>
        </div>
        <span className="rightButton" ref={(ref) => { this.refRightButton = ref; }}>
          {rightAction}
        </span>
      </header>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const propsHasShowBack = (ownProps.showBack === false || ownProps.showBack === true);
  const showBack = propsHasShowBack ? ownProps.showBack : state.header.showBack;
  return {
    headerContent: ownProps.content || state.header.content,
    showBack: showBack || state.header.showBack,
    backTitle: ownProps.backTitle || state.header.backTitle,
    rightAction: ownProps.rightAction || state.header.rightAction,
    leftAction: ownProps.leftAction,
    routerHistory: state.routerHistory,
  };
}

export default connect(mapStateToProps, {
  replace,
  routerHistoryBackAction,
  navigationShow,
})(Header);



// WEBPACK FOOTER //
// ./src/app/components/common/Header.js